import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, delay, distinctUntilChanged, filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Auth } from 'src/app/models/auth';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { CollaboratorFiltered } from 'src/app/models/collaborator';
import { FilterUseProducts } from 'src/app/models/relatorio';
import { ExtractRequest } from 'src/app/models/request/extract-request';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import {saveAs} from 'file-saver';
import { environment } from 'src/environments/environment';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { Product } from 'src/app/models/contract-assignor';

@Component({
  selector: 'app-relatorio-favorecido',
  templateUrl: './relatorio-favorecido.component.html',
  styleUrls: ['./relatorio-favorecido.component.css']
})
export class RelatorioFavorecidoComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private collaboratorsService: ColaboradorService,
    private alertService: NewAlertService,
    private contractService: ContratoService,
    public datepipe: DatePipe
  ) { }

  public currentUser: Auth;

  assignorContractList: CedenteContrato[];
  productList: Product[];

  //#region filter form
  public productsCtrl: FormControl = new FormControl();
  public collaboratorsServerSideCtrl: FormControl = new FormControl();
  public collaboratorsServerSideFilteringCtrl: FormControl = new FormControl();
  public searching = false;
  public collaboratorsFiltered: any;
  protected _onDestroy = new Subject<void>();

  public filtro = new FilterUseProducts(null,null,null,null,null);
  public filtroColaborador: any[] =[];
  public filtroProduto: number[] = [];
  public filtroCPF = '';

  public favorecidos: any;
  public filtroOn: boolean = false;

  public collaboratorsFilterText: string;
  public productsFilterText: string;

  public dataInicio = new Date();
  public dataFim = new Date();
  public dataMaxima = new Date();
  queryDate: Date;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.dataInicio.setDate(this.dataInicio.getDate()-2);
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.carregarRelatorio(1);
    this.getContracts();

    this.collaboratorsFiltered = this.collaboratorsServerSideFilteringCtrl.valueChanges
    .pipe(
      map(search => search.trim()),
      filter(search => search.length > 2 || !!search ),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(search => {
        return this.collaboratorsService.getCollaboratorFilter(this.currentUser.token.assignorGuid, search)
      }),
      map((res: any) => {
        this.searching = false;
        return res.result;
      }),
      delay(500),
      takeUntil(this._onDestroy)
    );
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getDetailedUseProducts(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.favorecidos = response.result.detailedUseProducts;
        this.totalItems = response.result.total;
        this.queryDate = new Date();
        for (const s of this.favorecidos) {;
          const tam = environment.TOTAL_CARACTERE_CPF - s.document.toString().length;
          let str = s.document.toString();

          for (let i = 0; i < tam; i++) { str = '0' + str; }

          s.document = str;
        }
      }
    });
  }  

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  setPeriod(inicio,date: Date){
    if(inicio){
      this.filtro.dateStart = date;
      this.dataMaxima = new Date(date.getFullYear(), date.getMonth(), date.getDate()+90);
      if (this.filtro.dateEnd >= this.dataMaxima){
        this.filtro.dateEnd = this.dataMaxima;
      } else if (this.filtro.dateEnd < this.filtro.dateStart){
        this.filtro.dateEnd =  this.filtro.dateStart;
      }
    } else {
      this.filtro.dateEnd = date;
    }
  }

  applyFilter() {
    this.filtro.dateStart;
    this.filtro.dateEnd;
    this.filtro.collaboratorsId = [];
    this.collaboratorsFilterText = '';
    this.productsFilterText = '';
    let colla = this.collaboratorsServerSideCtrl.value;
    this.filtro.productsId = this.productsCtrl.value;

    colla?.forEach((x, i) => {
      if(this.filtro.collaboratorsId.indexOf(x.id) == -1){
        this.filtro.collaboratorsId.push(x.id);
        this.collaboratorsFilterText += i==0 ? x.name : ', ' + x.name;
      }
    });
    this.filtro.productsId?.forEach((x, i)=> {
      this.productsFilterText += i==0 ?this.getProduct(x) : ', ' + this.getProduct(x);
    });

    if(
      this.filtro.dateStart == null &&
      this.filtro.dateStart == null &&
      this.filtro.productsId == null &&
      this.filtro.collaboratorsId
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    this.filtroOn = false;
    this.filtro = new FilterUseProducts(null,null,this.dataInicio,this.dataFim,null);

    this.dataMaxima = this.dataFim;
    this.productsCtrl.setValue(null);
    this.collaboratorsServerSideCtrl.setValue(null)

    this.filtroOn = false;

    this.carregarRelatorio(1);
  }

  getContracts(){
    this.contractService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                this.productList = response.result;
                if (this.productList.length <= 0 && this.productList.length <= 0) {
                    this.alertService.error(response.message);
                }
            } else {
                this.alertService.error(response.message);
            }
        },
        error => {
            this.alertService.error('Erro ao carregar o filtro de produtos' + error);
        }
    );
  }

  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'relatorio_utilizacao_detalhada_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Código','Tipo','CPF','Favorecido','Data e Hora','Produto','Categoria','Valor','Destino','Via'];
    ws.WorksheetRows = [];

    this.relatorioService.getDetailedUseProducts(this.currentUser.token.assignorGuid,0,this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.detailedUseProducts;

        for (const s of result) {;
          const tam = environment.TOTAL_CARACTERE_CPF - s.document.toString().length;
          let str = s.document.toString();

          for (let i = 0; i < tam; i++) { str = '0' + str; }

          s.document = str;
        }
        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.transactionCode);
          lr.push(r.type);
          lr.push(this.formatarCpf(''+r.document));
          lr.push(r.collaborator);
          lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm:ss.SSS'));
          lr.push(r.product);
          lr.push(r.productCategory);
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          lr.push(r.receipter);
          lr.push(this.paymentMethod(r.way));
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
        filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText + ' - ': ''
        filter += this.filtro.productsId?.length > 0 ? 'Produtos: ' + this.productsFilterText : ''

        /*excelService.generateExcel('Extrato Portal Cedente', worksheets).csv
        .writeBuffer({ encoding: 'UTF-8', formatterOptions: { delimiter: ';' } }).then((data) => {
            const blob = new Blob(['\ufeff', data], { type: 'text/csv; charset=UTF-8,'  });
            saveAs(blob, ws.worksheetTitle + '.csv');
        });*/

        excelService.generateExcelReport('Relatório de utilização detalhada', worksheets, filter).xlsx
        .writeBuffer().then((data) => {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error(
          'Ocorreu um erro ao paginar relatorio'
      );
      }
    );
  }

  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'relatorio_utilizacao_detalhada_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['Código','Tipo','CPF','Favorecido','Data e Hora','Produto','Categoria','Valor','','Destino','Via'];
    pdfData.PdfRows = [];

    this.relatorioService.getDetailedUseProducts(this.currentUser.token.assignorGuid,0,this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.detailedUseProducts;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.transactionCode);
          lr.push(r.type);
          lr.push(this.formatarCpf(''+r.document));
          lr.push(r.collaborator);
          lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm:ss.SSS'));
          lr.push(r.product);
          lr.push(r.productCategory);
          lr.push('R$');
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          lr.push(r.receipter);
          lr.push(this.paymentMethod(r.way));
          pdfData.PdfRows.push(lr);
        });

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
        filter += this.filtro.collaboratorsId?.length > 0 ? ' - Favorecidos: ' + this.collaboratorsFilterText: ''
        filter += this.filtro.productsId?.length > 0 ? ' - Produtos: ' + this.productsFilterText : ''

        //let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');

        const pdfService = new PdfService();
        pdfService.generatePdfReport('Relatório de utilização detalhada',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss'),true).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  paymentMethod(type: any) {
    switch (type) {
      case 1: return "Pix de resgate";
      case 2: return "Tarifa Bankei";
      case 3: return "Pix";
      case 4: return "Cartão";
      case 5: return "Boleto";
    }
  }

  formatarCpf(cpf){
      return cpf.slice(0,3)+"."+cpf.slice(3,6)+"."+cpf.slice(6,9)+"-"+cpf.slice(9);
  }

  getProduct(item){
    return this.productList.find(x => x.produtoId == item).descricaoProduto;
  }
}

